import technicalDataReducer from './reducers';

export { default as technicalDataTypes } from './types';
export { default as technicalDataActions } from './actions';
export { default as technicalDataSagas } from './sagas';

export default technicalDataReducer;
